import { render } from "./ResetPasswordManager.vue?vue&type=template&id=d55c9f5a&scoped=true"
import script from "./ResetPasswordManager.vue?vue&type=script&lang=js"
export * from "./ResetPasswordManager.vue?vue&type=script&lang=js"

import "./ResetPasswordManager.vue?vue&type=style&index=0&id=d55c9f5a&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d55c9f5a"]])

export default __exports__